import React from 'react'
import './style/complaint.css'
import { Link } from 'react-router-dom'
export default function Complaint() {
  return (
    <div className="sment">
      <div className="s_left">
        <Link to={'/statement'}>
          <div className="mz ">免责声明</div>
        </Link>
        <div className="ts sment_active">投诉处理</div>
      </div>
      <div className="statement">
        <div class="wrap_r">
          <p>
            &nbsp; &nbsp;
            空特下载站重视知识产权保护并遵守中国各项知识产权法律、法规和具有约束力的规范性文件。重视正版，打击盗版。根据法律、法规和规范性文件要求，空特下载站制定了旨在保护权利人的合法权益的措施和步骤，当权利人发现在空特下载站上的软件和资料的内容侵犯其合法权益时，权利人应事先向空特下载站发出“权利通知”，
            空特下载站将根据中国法律法规和政府规范性文件采取措施移除相关内容或屏蔽相关链接。
          </p>
          <p>&nbsp; &nbsp;具体措施和步骤如下：</p>
          <p>&nbsp; &nbsp;权利通知</p>
          <p>&nbsp; &nbsp;任何个人或单位如果同时符合以下两个条件：</p>
          <p>&nbsp; &nbsp;1、权利人发现网络用户利用网络服务侵害其合法权益；</p>
          <p>
            &nbsp;
            &nbsp;2、空特下载站上的软件和资料内容侵犯了上述权利人的合法权益。
          </p>
          <p>
            &nbsp;
            &nbsp;请上述个人或单位务必以书面的通讯方式或者电子邮件形式向空特下载站提交权利通知。请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章，否则空特下载站将不予受理。
          </p>
          <p>
            &nbsp;
            &nbsp;请注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定网络上可获取的资料是否侵犯了其合法权益，空特下载站建议该个人或单位首先咨询专业人士。
          </p>
          <p>
            &nbsp;
            &nbsp;为了空特下载站有效处理上述个人或单位的权利通知，请使用以下格式（包括各条款的序号）：
          </p>
          <p>
            &nbsp;
            &nbsp;1、请提供权利人具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件。
          </p>
          <p>
            &nbsp;
            &nbsp;2、请提供涉嫌侵权内容在空特下载站上的链接地址以便我们与您举报的发布侵权内容的所有权人/管理人联系。
          </p>
          <p>
            &nbsp;
            &nbsp;3、请提供您认为构成侵权的初步证明材料，包括但不限于您对软件或信息享有著作权或依法享有信息网络传播权的权属证明、创作手稿、经权威机构签发的作品创作时间戳、作品备案证书以及证明侵权事实的证据材料。
          </p>
          <p>
            &nbsp; &nbsp;4、请在权利通知中加入如下关于通知内容真实性的声明：
          </p>
          <p>
            &nbsp;
            &nbsp;（1）我本人为所投诉内容的合法权利人/我本人已获授权，有权行使相关权益；
          </p>
          <p>
            &nbsp;
            &nbsp;（2）在我举报的网页上登载的内容侵犯了本人相应的合法权益。
          </p>
          <p>
            &nbsp;
            &nbsp;（3）本人确认：如果本权利通知内容不完全属实，本人将承担由此产生的一切法律责任。
          </p>
          <p>&nbsp; &nbsp;5、请您把以上资料和联络方式书面发往以下地址：</p>
          <p>&nbsp; &nbsp;上海市浦东新区台儿庄路银桥大厦18楼1809</p>
          <p>&nbsp; &nbsp;邮政编码：200120。</p>
          <p>&nbsp; &nbsp;收件人：空特下载站</p>
          <p>
            &nbsp; &nbsp;或者以电子邮件方式发送至以下邮箱：support@sitename.com
          </p>
          <p>
            &nbsp;
            &nbsp;空特下载站收到您邮寄或发送的《书面通知》之后，将会对其进行审查，审查通过后将依据《信息网络传播权保护条例》的规定以及其他适用的法律法规将您要求删除的资源从空特下载站上删除或采取其他屏蔽、断开链接等必要措施。
          </p>
          <p>&nbsp; &nbsp;反通知</p>
          <p>
            &nbsp;
            &nbsp;空特下载站根据前述通知移除相关内容，同时有权按照适用的法律法规或内部处理规则将《书面通知》转交给推荐发布人，或者按照相关规定在平台上公告。被移除内容的内容提供者/所有权人/管理人可以依法向空特下载站发出关于被移除内容不侵犯著作权或其他合法权益的《申诉通知》。《申诉通知》发出后，空特下载站可以恢复被移除的内容或链接，且依法对该恢复行为不承担法律责任。
          </p>
          <p>
            &nbsp; &nbsp;
            请您以书面的通讯方式或者电子邮件方式向我们提交《申诉通知》。请注意：如果您《申诉通知》的陈述失实，您将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果您不确定网络上可获取的资料是否侵犯了他人的权利，我们建议您首先咨询专业人士。请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章。
          </p>
          <p>
            &nbsp;
            &nbsp;为了便于我们处理您的《申诉通知》，请使用以下格式（包括各条款的序号）：
          </p>
          <p>
            &nbsp; &nbsp; 1、请提供具体的联络信息，
            包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件。
          </p>
          <p>
            &nbsp;
            &nbsp;2、请指明被空特下载站移除的信息或内容的准确名称及链接地址。
          </p>
          <p>
            &nbsp;
            &nbsp;3、被移除内容的合法性证明，包括但不限于您对已移除的内容拥有著作权或其他合法权益的权属证明或您可以合法使用该作品或该内容的证明。
          </p>
          <p>
            &nbsp; &nbsp;4、请在反通知中加入如下关于反通知内容真实性的声明：
          </p>
          <p>&nbsp; &nbsp;（1）我本人为该作品/该内容的合法权利人；</p>
          <p>
            &nbsp; &nbsp;（2）我有权或已获授权提供或刊登上述被移除的信息或内容。
          </p>
          <p>
            &nbsp;
            &nbsp;（3）本人确认：本《申诉通知》内容充分、真实、准确，如果通知内容不完全属实，本人将承担由此产生的一切法律责任。
          </p>
          <p>&nbsp; &nbsp;5、请您把以上资料和联络方式书面发往以下地址：</p>
          <p>&nbsp; &nbsp;上海市浦东新区台儿庄路银桥大厦18楼1809</p>
          <p>&nbsp; &nbsp;邮政编码：200120。</p>
          <p>&nbsp; &nbsp;收件人：空特下载站</p>
          <p>
            &nbsp; &nbsp;或者以电子邮件方式发送至以下邮箱：support@sitename.com
          </p>
          <p>&nbsp; &nbsp;争议解决</p>
          <p>
            &nbsp;
            &nbsp;您充分理解并同意，空特下载站的平台管理人员并非专业人士，仅能以普通人认知对被投诉内容是否侵权进行判断；除非存在故意或重大过失的情形，空特下载站无需对是否采取必要措施的行为承担法律责任。
          </p>
          <p>
            &nbsp;
            &nbsp;空特下载站实施反通知程序保留原有资源后，如果您仍然认为空特下载站所保留的内容侵犯了您的著作权，坚持要求空特下载站删除的，您应当直接与空特下载站客服【邮箱：support@sitename.com】取得联系；对于双方之间的争议，双方应当友好协商解决；协商不成的，任何一方均可提请北京市海淀区人民法院诉讼解决。
          </p>
          <p>
            &nbsp;
            &nbsp;有关本声明以及本声明执行过程中产生的一切争议，均应适用中华人民共和国法律。
          </p>
        </div>
      </div>
    </div>
  )
}
